import { Link } from 'react-router-dom';
import * as Lucide from 'lucide-react';
import { ArrowRight } from 'lucide-react';
import PageHeader from '../components/PageHeader';
import CTA from '../components/CTA';
import { products } from '../mock';
import { useSeo } from '../hooks/useSeo';

const ProductsPage = () => {
  useSeo({
    title: 'Urunler',
    description:
      'Asma germe sistemleri, endustriyel depo cadirlari, celik yapilar, kiralik dome cadirlari, ucak hangarlari, halisaha cadirlari, sisme cadirlar ve santiye cadirlari.',
    path: '/urunler',
  });

  return (
    <main>
      <PageHeader
        eyebrow="URUNLERIMIZ"
        title="Kapsamli Cozum Portfoyu"
        description="Her projeye ozel, mukemmellik odakli sekiz farkli urun ailesi. Detayli bilgi ve galeri icin urun kartina tiklayin."
      />

      {/* Product cards grid */}
      <section className="px-6 lg:px-10 pb-24">
        <div className="max-w-[1300px] mx-auto grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((p, i) => {
            const Icon = Lucide[p.icon] || Lucide.Box;
            return (
              <Link
                key={p.slug}
                data-testid={`product-card-${p.slug}`}
                to={`/urunler/${p.slug}`}
                className="group relative rounded-2xl overflow-hidden bg-card border border-border hover:border-primary/60 transition-all duration-500 hover:-translate-y-1 hover:shadow-xl hover:shadow-primary/10 block"
              >
                {/* Image */}
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-transparent" />

                  {/* Icon badge */}
                  <div className="absolute top-4 left-4 w-11 h-11 rounded-xl bg-background/80 backdrop-blur-md border border-primary/40 flex items-center justify-center group-hover:bg-primary group-hover:border-primary transition-all duration-500">
                    <Icon
                      size={19}
                      strokeWidth={1.6}
                      className="text-accent group-hover:text-primary-foreground transition-colors duration-500"
                    />
                  </div>

                  {/* Number */}
                  <div className="absolute top-4 right-4 text-[11px] tracking-wider text-white/75 font-medium">
                    0{i + 1}
                  </div>
                </div>

                {/* Text */}
                <div className="p-6">
                  <h3 className="text-[18px] font-semibold text-white mb-2 leading-snug group-hover:text-accent transition-colors">
                    {p.title}
                  </h3>
                  <p className="text-[13px] text-white/55 leading-relaxed line-clamp-3">
                    {p.description}
                  </p>
                  <div className="mt-5 flex items-center justify-between">
                    <span className="text-[11px] tracking-[0.2em] font-semibold text-accent uppercase">
                      Detaylari Gor
                    </span>
                    <ArrowRight
                      size={16}
                      className="text-accent group-hover:translate-x-1 transition-transform"
                    />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </section>

      <CTA />
    </main>
  );
};

export default ProductsPage;
